<template lang="html">
  <div ref="bilancio">
    <h2>Anno di attività:</h2>
    <div style="display: inline-block">
      Anno:
      <Select v-model="year" @input="refreshLedgers()">
        <Option v-for="y in years" :key="y" :value="y">{{ y }}</Option>
      </Select>
    </div>
    <div style="display: inline-block">
      Bilancio prima del
      <LocalDate v-model="before_date" @input="refreshLedgers()"/>
    </div>
    &nbsp;
    <Button type="primary" @click.native="print_loading = true; $utils.download(`piano-conti-${year}.pdf`, 'ledgers', Object.assign({_print:1}, params), () => {print_loading = false})" :loading="print_loading">
      Stampa piano dei conti
    </Button>
    &nbsp;
    <Button type="primary" @click.native="print_loading2 = true; $utils.download(`bilancio-${year}.pdf`, 'ledgers', Object.assign({_print:2}, params), () => {print_loading2 = false})" :loading="print_loading2">
      Stampa bilancio
    </Button>

    <br>
    <br>

    <Row :gutter="16">
      <Col v-for="type in types" :key="type.label" :md="type.span" style="margin: 40px 0 20px">
        <h1 style="font-size: 300%">{{ type.label }}</h1>
        <br v-if="piano = ledgers.filter(type.filter)">
        <div v-if="piano.map(l => l.category).unique().length == 0">
          <i>Nessun conto movimentato</i>
        </div>
        <div class="ivu-table spaced" style="margin: 1em 0">
          <template v-for="cat in piano.map(l => l.category).unique()" v-if="tabella = piano.filter(l => l.category == cat)">
            <table>
              <thead>
                <tr>
                  <th colspan="6">{{ cat }}</th>
                </tr>
                <tr>
                  <th style="width: 70px">Codice</th>
                  <th style="">Nome</th>
                  <th>Descrizione</th>
                  <th style="width: 100px; text-align: right">Dare</th>
                  <th style="width: 100px; text-align: right">Avere</th>
                  <th style="width: 100px; text-align: right">Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!tabella.length">
                  <td colspan=3>
                    Nessun mastro presente
                  </td>
                </tr>
                <tr v-for="l in tabella" :key="l.id">
                  <td>{{ l.code }}</td>
                  <td><b>{{ l.name }}</b></td>
                  <td><i>{{ l.description }}</i></td>
                  <td class="text-right text-success">{{ $n((l.stats || {}).dare, 'currency') }}</td>
                  <td class="text-right text-error">{{ $n((l.stats || {}).avere, 'currency') }}</td>
                  <td class="text-right text-info">{{ $n((l.stats || {}).saldo, 'currency') }}</td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right text-success">{{ $n(_.sum(tabella.map(l => (parseFloat((l.stats || {}).dare) || 0))), 'currency') }}</td>
                  <td class="text-right text-error">{{ $n(_.sum(tabella.map(l => (parseFloat((l.stats || {}).avere) || 0))), 'currency') }}</td>
                  <td class="text-right text-info">{{ $n(_.sum(tabella.map(l => (parseFloat((l.stats || {}).saldo) || 0))), 'currency') }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
        <div class="text-right" style="margin: 10px 100px 30px; font-size: 120%">
          <h2>Totali Piano {{ type.label }}:</h2>
          <br>
          Totale DARE:
          <span class="text-success">{{ $n(_.sum(piano.map(l => (parseFloat((l.stats || {}).dare) || 0))), 'currency') }}</span>
          <br>
          Totale AVERE:
          <span class="text-error">{{ $n(_.sum(piano.map(l => (parseFloat((l.stats || {}).avere) || 0))), 'currency') }}</span>
          <br>
          SALDO:
          <span class="text-info">{{ $n(_.sum(piano.map(l => (parseFloat((l.stats || {}).saldo) || 0))), 'currency') }}</span>
        </div>
        <br>
      </Col>
      <Spin size="large" fix v-if="loading"/>
    </Row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      print_loading: false,
      print_loading2: false,
      loading: true,
      ledgers: [],
      years: [],
      year: (new Date).getFullYear(),
      before_date: null,
      types: [
        { span: 24, label: 'Patrimoniale Attivo', filter: i => i.type == 'pa' },
        { span: 24, label: 'Patrimoniale Passivo', filter: i => i.type == 'pp' },
        { span: 24, label: 'Economico', filter: i => i.type.startsWith('ce') },
      ],
      document,
    }
  },

  mounted() {
    this.refreshLedgers()
    this.$http.get('contab-years?company_id=' + this.$store.company.id).then(res => {
      this.years = res.data.map(y => parseInt(y))
    })
  },

  methods: {
    refreshLedgers(print) {
      this.loading = true
      this.$http.get('ledgers', {
        params: this.params,
      }).then(res => {
        this.ledgers = res.data
      }).finally(res => {
        this.loading = false
      })
    },
  },

  computed: {
    params () {
      return {
        company_id: this.$store.company.id,
        stats: 1,
        year: this.year,
        before_date: this.before_date,
      }
    }
  },

  watch: {
    before_date (v) {
      if (v && v.split('-')[0] != this.year) this.year = parseInt(v.split('-')[0])
    },
    year (v) {
      if (this.before_date && this.before_date.split('-')[0] != v) this.before_date = null
    },
  }
}
</script>

<style lang="css">
</style>
